import {setPlayersEditPhotoMode, setPlayersIsShowModal} from "../DartsPlayersCRUD.slice";
import { api } from "../../../../services/api/api.service";
import {AppDispatch} from "../../../../store";
import React from "react";
import { API_PLAYERS_PHOTO } from "../../../../services/api/api.urls";

interface IShowFullSizePhoto {
    id: number;
    setIsExistPhoto: React.Dispatch<React.SetStateAction<string>>
    dispatch: AppDispatch;
}
export const showFullSizePhoto = async ({id, setIsExistPhoto, dispatch}: IShowFullSizePhoto) => {
    try {
        setIsExistPhoto('');
        dispatch(setPlayersIsShowModal(true))
        dispatch(setPlayersEditPhotoMode(true))
        // ToDo: ������ � TryCatch
        const playersPhoto = await api.get(`${API_PLAYERS_PHOTO}/${id}`)
        setIsExistPhoto(playersPhoto.data)

    } catch {
    }
}
